import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Drawer,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { MVPFiltersProps } from '../../advanta-mvp-charts/constants';
import { MVPDataTableInternal } from '../components/table';
import { Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import ImportUsersDrawer from '../components/importUserDrawer';
import CommonAppBarAdmin from '../../../components/commonAppBarAdmin';
import * as yup from 'yup';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import { InputController } from '../../../components';
import {
  TFieldDetails2,
  TFieldReport,
  TRequestTableDataByTableType,
} from '../../../types/mvpCharts';
import EditIcon from '@mui/icons-material/Edit';
import EditDrawer from '../components/editDrawer';
import {
  useAddOrUpdateDataByTableTypeMutation,
  useGetTableDataByTableTypeQuery,
} from '../../../services/mVPGraphQlService';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../../services/alert';
import arrow from '../../../assets/icons/line_arrow-close-left.svg';
import { RootState } from '../../../store';

export const userSchema = yup.object({
  region: yup.string().required('region is required'),
  subRegion: yup.string().required('subregion is required'),
  subRegionCode: yup
    .string()
    .required('subregionCode is required'),
  cluster: yup.string(),
  village: yup.string().required('village is required'),
});

export const GeographyManagement: React.FC<
  MVPFiltersProps
> = ({ onNavigate, onBack }) => {
  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const countryName = useSelector(
    (state: RootState) => state.country.countryName
  );

  const isNonIndia = countryName !== 'India';

  const defaultValues = {
    region: '',
    subRegion: '',
    subRegionCode: '',
    village: '',
    cluster: '',
  };

  const formSchema = yup.object({
    region: yup.string().required('region is required'),
    subRegion: yup
      .string()
      .required('subregion is required'),
    subRegionCode: yup
      .string()
      .required('subregionCode is required'),
    cluster: isNonIndia
      ? yup.string().required('cluster is required')
      : yup.string(),
    village: yup.string().required('village is required'),
  });

  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues,
  });

  const [openDrawer, setOpenDrawer] = useState(false);
  const handleOpenDrawer = () => setOpenDrawer(true);
  const handleCloseDrawer = () => {
    reset(defaultValues);
    setOpenDrawer(false);
  };
  const [openImportDrawer, setOpenImportDrawer] =
    useState(false);
  const [openEditDrawer, setOpenEditDrawer] =
    useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState<
    TFieldReport[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allTableData, setAllTableData] = useState<
    TFieldReport[]
  >([]);

  const [addorUpdateRequest] =
    useAddOrUpdateDataByTableTypeMutation();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const obj = {
      dataType: 'DT_ROW',
      tableType: 'TT_GEOGRAPHY',
      wsId: wsId,
      dataPayload: {
        geoRecord: {
          region: data.region,
          subRegion: data.subRegion,
          village: data.village,
          ...(isNonIndia && { cluster: data.cluster }),
          subRegionCode: data.subRegionCode,
          country: countryName,
        },
      },
    };

    addorUpdateRequest(obj)
      .unwrap()
      .then((response) => {
        const inspectionData =
          response?.data?.AddOrUpdateDataByTableType;
        if (
          inspectionData?.responseStatus?.status ===
          'SUCCESS'
        ) {
          reset();
          setOpenDrawer(false);
          dispatch(
            showAlert({
              content: 'Geography added successfully',
            })
          );
          refetch();
        } else {
          dispatch(
            showAlert({
              content: `${inspectionData?.responseStatus?.errorMessages?.[0]}`,
              severity: 'error',
            })
          );
        }
      })

      .catch((err) => {
        console.error('Error:', err);
        dispatch(
          showAlert({
            content: 'something went wrong2',
            severity: 'error',
          })
        );
      });
  };

  const queryParams: TRequestTableDataByTableType = {
    tableType: 'TT_GEOGRAPHY',
    pageNumber: pageNo,
    pageSize: pageSize,
    wsId: wsId,
  };

  const {
    data: getTableData,
    isLoading,
    isFetching,
    refetch,
  } = useGetTableDataByTableTypeQuery(queryParams);

  const headers =
    getTableData?.data?.GetTableDataByTableType?.tableMeta
      ?.headers;
  const PRIMARY_FIELD = headers?.[0]; //active col

  const remainingHeaders = headers?.slice(1);

  useEffect(() => {
    if (
      getTableData?.data?.GetTableDataByTableType
        ?.geographies
    ) {
      setTotalCount(
        getTableData?.data?.GetTableDataByTableType
          ?.totalCount || 0
      );
      setTableData(
        getTableData?.data?.GetTableDataByTableType
          ?.geographies
      );

      setAllTableData(
        getTableData?.data?.GetTableDataByTableType
          ?.geographies
      );
    }
  }, [getTableData]);
  const handlePageChange = (
    event: React.MouseEvent | null,
    newPageNumber: number
  ) => {
    setPageNo(newPageNumber);
    setTableData(
      getPaginatedData(
        newPageNumber,
        pageSize,
        allTableData
      )
    );
  };

  const getPaginatedData = (
    newPageNumber: number,
    itemsPerPage: number,
    allItemsList: TFieldReport[]
  ) => {
    const indexOfLastItem =
      (newPageNumber + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPageItems = allItemsList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    return [...currentPageItems];
  };

  const columnsss = [
    {
      key: '',
      label: '',
      cellModifier: () => {
        return '';
      },
    },
    {
      key: PRIMARY_FIELD,
      label: PRIMARY_FIELD,
      cellModifier: (row: TFieldDetails2) => {
        return assigneeNode(row);
      },
    },

    ...(Array.isArray(remainingHeaders)
      ? remainingHeaders.map((item) => ({
          key: item,
          label: item,
        }))
      : []),
  ];

  const [hoveredRow, setHoveredRow] = useState<
    number | null
  >(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<
    number | null
  >(null);

  const [selectedFieldNo, setSelectedFieldNo] = useState<
    number | null
  >(null);

  const assigneeNode = (tableRowData: any) => {
    const rowIndex =
      getTableData?.data?.GetTableDataByTableType?.geographies?.findIndex(
        (item) => item.geoId === tableRowData.geoId
      );

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onMouseEnter={() =>
          setHoveredRow(tableRowData?.geoId)
        }
        onMouseLeave={() => setHoveredRow(null)}>
        <Typography fontSize={13} fontWeight={600}>
          {tableRowData?.geoId}
        </Typography>

        {hoveredRow === tableRowData?.geoId && (
          <IconButton
            type="button"
            onClick={() => {
              setOpenEditDrawer(true);
              setSelectedFieldNo(tableRowData.geoId);
              setSelectedRowIndex(rowIndex); // ✅ store index
            }}>
            <EditIcon />
          </IconButton>
        )}
      </Box>
    );
  };

  return (
    <div>
      <CommonAppBarAdmin
        height={'auto'}
        title={'Geography Management'}
        onBack={onBack}
        section={
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}></Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}>
              <Button
                startIcon={<HistoryIcon />}
                onClick={() =>
                  onNavigate?.('importHistory')
                }
                sx={{
                  textTransform: 'none',
                  color: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                }}>
                View History
              </Button>

              <Button
                startIcon={<AddIcon />}
                variant="outlined"
                onClick={handleOpenDrawer}
                sx={{
                  textTransform: 'none',
                  borderColor: 'rgba(0,105,112,1)',
                  color: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                  '&:hover': {
                    borderColor: 'rgba(0,105,112,0.8)',
                    backgroundColor: 'rgba(0,105,112,0.05)',
                  },
                }}>
                Add Geography
              </Button>

              <Button
                startIcon={<DownloadIcon />}
                variant="contained"
                onClick={() => setOpenImportDrawer(true)}
                sx={{
                  textTransform: 'none',
                  backgroundColor: 'rgba(0,105,112,1)',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: 'rgba(0,105,112,0.9)',
                  },
                }}>
                Import Geography
              </Button>
            </Box>
          </>
        }
      />

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: '50vw',

            backgroundColor: '#fff',
          },
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid #E0E0E0',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.04)',
          }}>
          <Typography
            fontSize={17}
            fontWeight={600}
            sx={{ lineHeight: 1 }}>
            Add Geography
          </Typography>

          <Box
            onClick={handleCloseDrawer}
            sx={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}>
            <img
              src={arrow}
              alt="close"
              style={{ width: 20, height: 20 }}
            />
          </Box>
        </Box>

        <form
          onSubmit={handleSubmit((data) => onSubmit(data))}
          className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 px-6 py-6 pb-24 md:pb-28">
          <InputController
            label="Region"
            register={register('region')}
            error={errors?.region?.message}
            required
          />
          <InputController
            label="Sub region"
            register={register('subRegion')}
            error={errors?.subRegion?.message}
            required
          />
          <InputController
            label="Sub region code"
            register={register('subRegionCode')}
            error={errors?.subRegionCode?.message}
            required
          />
          {isNonIndia && (
            <InputController
              label="Cluster"
              register={register('cluster')}
              error={errors?.cluster?.message}
              required
            />
          )}

          <InputController
            label="Village"
            register={register('village')}
            error={errors?.village?.message}
            required
          />

          <div className="col-span-full form-control mt-8 flex justify-end gap-4">
            <Button
              variant="outlined"
              onClick={handleCloseDrawer}
              className="mr-2"
              sx={{
                color: '#006970',
                borderColor: '#006970',
              }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'rgba(0,105,112,1)' }}
              type="submit">
              Save
            </Button>
          </div>
        </form>
      </Drawer>
      <ImportUsersDrawer
        open={openImportDrawer}
        onClose={() => setOpenImportDrawer(false)}
        type={'geography'}
        refetch={refetch}
      />
      <EditDrawer
        open={openEditDrawer}
        onClose={() => setOpenEditDrawer(false)}
        type={'geography'}
        schema={userSchema}
        data={
          getTableData?.data?.GetTableDataByTableType
            ?.geographies
        }
        rowIndex={selectedRowIndex}
        refetch={refetch}
      />
      <div style={{ marginTop: 140 }}></div>
      {isLoading || isFetching ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="60vh">
          <CircularProgress />
        </Box>
      ) : (
        <MVPDataTableInternal
          type={'geography'}
          columns={columnsss}
          data={tableData}
          selectedFieldNo={selectedFieldNo}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalCount={totalCount}
          pageNo={pageNo}
          setPageNo={setPageNo}
          isLoading={false}
          rowsPerPageOptions={[pageSize]}
          handlePageChange={handlePageChange}
          rowKey={'geoId'}
        />
      )}
    </div>
  );
};
